export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB in bytes

export const MAX_FILE_SIZE_VALUE = 50;

export const URBAN_COMPASS_SITE = 'https://urbancompasssoftware.com/';
